import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { apiClient } from '../../services/api';

export function useHeaderIndicatorsQuery() {
  const { user } = useAuth();
  const tenantId = user?.tenantId;
  const userId = user?.userId;

  return useQuery({
    queryKey: ['header-indicators', tenantId, userId],
    queryFn: () => apiClient.getHeaderIndicators(tenantId!, userId!),
    enabled: !!tenantId && !!userId,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}

